import script from "./control-ai-chat.vue?vue&type=script&setup=true&lang=ts"
export * from "./control-ai-chat.vue?vue&type=script&setup=true&lang=ts"

import "./control-ai-chat.vue?vue&type=style&index=0&id=4bce459f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bce459f"]])

export default __exports__